<template>
  <div>
    <sortPrice @sortType="sortType"></sortPrice>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getList"
      class="right"
    >
      <productionList :productlist="datas"></productionList>
    </van-list>
  </div>
</template>
<script>
import productionList from '@/components/productList'
import { sortPrice } from './components'
import { goodsList } from '@/api/goods'

export default {
  components: {
    productionList,
    sortPrice
  },
  data () {
    return {
      datas: [],
      loading: false,
      finished: false,
      page: 0
    }
  },
  methods: {
    async getList (sortType = {}) {
      console.log(sortType);

      //判断是几级分类
      const routerCateType = this.$route.query.cate_type;
      const cate_type = {
        ['1']: 'first_cat_id',
        ['2']: 'second_cat_id',
        ['3']: 'third_cat_id'
      }
      this.page++;
      this.loading = true;
      const result = await goodsList({
        //筛选
        ...sortType,
        page: this.page,
        size: 6,
        keyword: this.$route.query.keyword || null,
        [cate_type[routerCateType]]: this.$route.query.cat_id || null,
      })

      this.loading = false;
      if (result.data.data.goodsList.data.length !== 0) {
        this.datas = this.datas.concat(result.data.data.goodsList.data)
      } else {
        this.finished = true
      }
    },
    sortType (value) {
      console.log(value);
      this.page = 0
      this.finished = false
      this.datas = []
      this.getList(value)
    },
  }
}
</script>
<style lang="scss" scoped></style>